import { render, staticRenderFns } from "./ActionsGroup.vue?vue&type=template&id=23f56d1e&scoped=true"
import script from "./ActionsGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionsGroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActionsGroup.vue?vue&type=style&index=0&id=23f56d1e&prod&lang=scss&scoped=true"
import style1 from "./ActionsGroup.vue?vue&type=style&index=1&id=23f56d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f56d1e",
  null
  
)

export default component.exports